var orderServiceObj =
{
    getOffers(orderId) {
        return axios.get('api/Order/Offers/' + orderId);
    },

    getPdfOffer(orderId) {
        return axios.get('api/Order/Pdf/' + orderId);
    },

    getOffer(orderId, insurer, period, cacheKey, showExtraOffers, directSettlement) {
        return axios.get('api/Order/retrieveOffer',
            {
                params:
                {
                    orderId: orderId,
                    insurer: insurer,
                    period: period,
                    cacheKey: cacheKey,
                    showExtraOffers: showExtraOffers,
                    directSettlement: directSettlement
                }
            });
    },

    getOrderSelectedOffer(orderId) {
        return axios.get('api/Order/SelectedOffer/' + orderId);
    },

    confirmOrder(offer) {
        return axios.post('api/Order/ConfirmOrder', offer);
    },

    getOfferForEdit(offerId) {
        return axios.get('api/Order/Offer/' + offerId);
    },

    saveOffer(offer) {
        return axios.post('api/Order/Offer', offer);
    },

    getOrdersPage(pageParams) {
        return axios.post('api/Order/GetOrdersPage', pageParams);
    },

    getTempOrders() {
        return axios.get('api/Order/Temporary');
    },

    getExpiringOrdersPage(pageParams) {
        return axios.post('api/Order/GetExpiringOrdersPage', pageParams);
    },

    getPaymentsPage(pageParams) {
        return axios.post('api/Order/GetPaymentsPage', pageParams);
    },

    getOrder(id, type, renew) {
        return axios.get('api/Order/' + id + '/' + type + '/' + renew);
    },
    getOrderRemarks(id) {
        return axios.get('api/Order/' + id + '/remarks');
    },

    getTempOrder(id) {
        return axios.get('api/Order/Temp/' + id );
    },

    getOrderType(id) {
        return axios.get('api/Order/Type/' + id);
    },

    getOldPolicy(id) {
        return axios.get('api/Order/OldPolicy/' + id);
    },

    getOrderTypes() {
        return axios.get('api/Order/Types');
    },

    getOrderTypeSettings() {
        return axios.get('api/Order/TypeSettings');
    },

    saveOrder(order) {
        return axios.post('api/Order', order);
    },
    saveOrderRemarks(orderId, remark) {
        return axios.post('api/Order/saveRemarks', { OrderId: orderId, Text: remark });
    },

    cacheOrder(order) {
        console.log('saveOrder:' + order.Id)
        return axios.post('api/Order/CacheOrder', order);
    },

    saveTempOrder(order) {
        return axios.post('api/Order/SaveTempOrder', order);
    },

    saveOrderType(orderType) {
        return axios.post('api/Order/Type', orderType);
    },

    savePayment(payment) {
        return axios.post('api/Order/Payment', payment);
    },

    changeStatus(order) {
        return axios.post('api/Order/ChangeStatus', order);
    },

    cancelOrder(order) {
        return axios.post('api/Order/CancelOrder', order);
    },

    finishOrder(finishInfo) {
        return axios.post('api/Order/FinishOrder', finishInfo);
    },
    sendEmails(finishInfo) {
        return axios.post('api/Order/SendEmails', finishInfo);
    },

    requestPayment(paymentId) {
        return axios.post('api/Order/RequestPayment', { "Id": paymentId });
    },

    deleteOrder(id, rowVersion) {
        return axios.delete('api/Order', { params: { id: id, rowVersion: rowVersion } });
    },

    deleteTempOrder(id, rowVersion) {
        return axios.delete('api/Order/Temp', { params: { id: id, rowVersion: rowVersion } });
    },

    deleteOrderType(id, rowVersion) {
        return axios.delete('api/Order/Type', { params: { id: id, rowVersion: rowVersion } });
    },

    getCompanyList() {
        return axios.get('api/Company/');
    },

    getVehicleListByUniqueKey(query, type) {
        return axios.get('api/order/getVehicleListByUniqueKey', { params: { query: query, type: type } })
    },
    getVehicleListByOwnerId(id) {
        return axios.get('api/order/GetVehicleListByOwnerId', { params: { id: id } })
    },


   


    // enums
    orderStatus:
    {
        none: 0, // seen only by the user / incomlete
        request: 1, // visible for operator completed
        confirmed: 2, // offer accepted
        policy: 4, // Policy issued
        canceled: 5, // policy canceled
        blocked: 6, // policy blocked
    },

    requestStatus:
    {
        new: 0, // seen only by the user / incomlete
        inProgress: 1, // in progress
        done: 2, // policy blocked
    },

    requestType:
    {
        issuePolicy: 0,
        rceivePayment: 1,
    },

    getOrderStatusList: function () {
        return [

            //{ Value: this.orderStatus.none, Name: 'Toate' },
            //{ Value: this.orderStatus.request, Name: 'Oferta' },
            { Value: this.orderStatus.confirmed, Name: 'Confirmata' },
            { Value: this.orderStatus.policy, Name: 'Polita' },
            { Value: this.orderStatus.canceled, Name: 'Anulata' },
            { Value: this.orderStatus.blocked, Name: 'Blocata' },
        ];
    },

    getrequestStatusList: function () {
        return [
            { Value: this.requestStatus.new, Name: 'Cerere' },
            { Value: this.requestStatus.inProgress, Name: 'In lucru' },
            { Value: this.requestStatus.done, Name: 'Finalizat' },
        ];
    },

    orderSubtype:
    {
        none: 0,
        mandatory: 1,
        optional: 2
    }
}

export const orderService = orderServiceObj;
